import React, { useEffect, useState } from "react";
import { useAuthStore } from "../../store/authStore";
import { useAutoLogin } from "../../hooks/auth/useAutoLogin";

interface AuthProviderProps {
  children: React.ReactNode;
}

const AuthProvider = ({ children }: AuthProviderProps) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const { isAuthenticated, refreshToken } = useAuthStore();
  const { autoLogin, isAutoLogging } = useAutoLogin();

  useEffect(() => {
    const initializeAuth = async () => {
      if (isAuthenticated || !refreshToken) {
        setIsInitialized(true);
        return;
      }

      await autoLogin();
      console.log("자동 로그인 완료");
      setIsInitialized(true);
    };

    initializeAuth();
  }, [isAuthenticated, refreshToken, autoLogin]);

  if (!isInitialized || isAutoLogging) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-slate-50 to-white">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500 mx-auto mb-4"></div>
          <p className="text-gray-600">로그인 상태를 확인하고 있습니다...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthProvider;
